module.exports = __webpack_public_path__ + "memory.2706fb01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/feeds/memory.png
// module id = 1515
// module chunks = 0